<ng-container *ngIf="twoFactorType">
  <app-profile-base-form>
    <ng-container form-controls>
      <div [ngSwitch]="twoFactorType" class="two-auth-title">
        <div
          *ngSwitchCase="twoFactorTypeEnum.email"
          [innerHTML]="'account-profile.common.two-auth.title.email' | translate : { email }"
        ></div>
        <div
          *ngSwitchCase="twoFactorTypeEnum.googleAuth"
          [innerHTML]="'account-profile.common.two-auth.title.googleAuth' | translate"
        ></div>
      </div>

      <ng-content></ng-content>

      <label class="cm-label two-auth-label">
        <ng-container [ngSwitch]="twoFactorType">
          <ng-container *ngSwitchCase="twoFactorTypeEnum.email">
            <svg-icon src="/assets/icons/icon-email.svg" svgClass="mr-1"></svg-icon>
            {{ '2fa.code-email' | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="twoFactorTypeEnum.googleAuth">
            <svg-icon src="/assets/icons/icon-google-device.svg" svgClass="mr-1"></svg-icon>
            {{ '2fa.code-mfa' | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="twoFactorTypeEnum.trezor">
            <svg-icon src="/assets/icons/icon-trezor.svg" svgClass="mr-1"></svg-icon>
            {{ '2fa.please-authorize-trezor' | translate }}
          </ng-container>
        </ng-container>
      </label>
      <ng-container *ngIf="twoFactorType === twoFactorTypeEnum.email || twoFactorType === twoFactorTypeEnum.googleAuth">
        <app-otp-input (otpCompleted)="onTwoFactorCodeCompleted($event)"></app-otp-input>
      </ng-container>
      <div *ngIf="twoFactorType === twoFactorTypeEnum.trezor && !this.hasTrezorTwoFactorData" class="two-auth-trezor">
        <app-action-button
          label="2fa.verify"
          type="button"
          facet="primary"
          size="small"
          (action)="performTrezorTwoFactor()"
          [waiting]="this.trezorTwoFactorLoadState === loadStateEnum.loading"
        ></app-action-button>
      </div>
    </ng-container>
    <ng-container form-buttons>
      <app-action-button
        label="shared.common.cancel"
        type="reset"
        [facet]="'secondary'"
        size="small"
        (action)="onTwoFactorCancel()"
      ></app-action-button>
    </ng-container>
  </app-profile-base-form>
</ng-container>
